import { useTranslation } from "react-i18next";
import "./TermsAndConditions.scss";
import { useEffect } from "react";

const TermsAndConditions = () => {
  const { t } = useTranslation("common");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="term-condition-section">
      <div className="container">
        <h1 className="term-condition-heading">
          {t("terms_of_service.heading")}
        </h1>

        <div>
          {/* <h4 className="main-heading">{t("terms_of_service.main-heading")}</h4> */}
        </div>

        <div>
          <h3 className="inner-heading">
            1. {t("privacy_policy.introduction_heading")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("privacy_policy.introduction") }}></p>
        </div>

        <div>
          <h3 className="inner-heading">
            2. {t("privacy_policy.information_we_collect_heading")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("privacy_policy.information_we_collect.content") }}>

          </p>
        </div>
        <div>
          <h3 className="inner-heading">
            3. {t("privacy_policy.how_we_use_your_information.title")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("privacy_policy.how_we_use_your_information.content") }}>
          </p>
        </div>
        <div>
          <h3 className="inner-heading">
            4. {t("privacy_policy.data_security.title")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("privacy_policy.data_security.content") }}>

          </p>
        </div>
        <div>
          <h3 className="inner-heading" >
            5. {t("privacy_policy.data_retention.title")}
          </h3>
          <p className="inner-heading">
            {t("privacy_policy.data_retention.content")}
          </p>
        </div>

        <div>
          <h4 className="main-heading" dangerouslySetInnerHTML={{ __html: t("terms_of_service.main-heading") }}></h4>
        </div>

        <div>
          <h3 className="inner-heading">
            1. {t("terms_of_service.eligibility.title")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("terms_of_service.eligibility.content") }}>

          </p>
        </div>

        <div>
          <h3 className="inner-heading">
            2. {t("terms_of_service.user_accounts.title")}
          </h3>
          <p className="inner-heading">
            {t("terms_of_service.user_accounts.content")}
          </p>
        </div>

        <div>
          <h3 className="inner-heading">
            3. {t("terms_of_service.platform_use.title")}
          </h3>
          <p className="inner-heading">
            {t("terms_of_service.platform_use.content")}
          </p>
        </div>

        <div>
          <h3 className="inner-heading">
            4. {t("terms_of_service.tournaments_and_prizes.title")}
          </h3>
          <p className="inner-heading">
            {t("terms_of_service.tournaments_and_prizes.content")}
          </p>
        </div>

        <div>
          <h3 className="inner-heading">
            5. {t("terms_of_service.payments.title")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("terms_of_service.payments.content") }}>

          </p>
        </div>

        {/* <div>
          <h3 className="inner-heading">
            {t("terms_of_service.intellectual_property.title")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("terms_of_service.intellectual_property.content") }}>
          </p>
        </div> */}

        <div>
          <h3 className="inner-heading">
            6. {t("terms_of_service.promotional_use.title")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("terms_of_service.promotional_use.content") }}>

          </p>
        </div>

        <div>
          <h3 className="inner-heading">
            7. {t("terms_of_service.complaints_and_disputes.title")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("terms_of_service.complaints_and_disputes.content") }}>

          </p>
        </div>

        <div>
          <h3 className="inner-heading">
            8. {t("terms_of_service.modifications_and_termination.title")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("terms_of_service.modifications_and_termination.content") }}>
          </p>
        </div>

        <div>
          <h3 className="inner-heading">
            9. {t("terms_of_service.governing_law.title")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("terms_of_service.governing_law.content") }}>

          </p>
        </div>

        <div>
          <h3 className="inner-heading">
            9. {t("terms_of_service.account_and_data_deletion.title")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("terms_of_service.account_and_data_deletion.content") }}>

          </p>
        </div>

        <div>
          <h3 className="inner-heading">
            9. {t("terms_of_service.information_we_collect.title")}
          </h3>
          <p className="inner-heading" dangerouslySetInnerHTML={{ __html: t("terms_of_service.information_we_collect.content") }}>

          </p>
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;
